import { defineStore } from "pinia";
import axios from "axios";
import axiosRetry from "axios-retry";
import { Auth0Client } from "@auth0/auth0-spa-js";
import { HttpState } from "@/stores/http/types.ts";

const axiosBaseConfig = {
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFToken",
};

let baseUrl = import.meta.env.VITE_API_URL;
baseUrl += baseUrl.endsWith("/") ? "" : "/";

axiosRetry(axios, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
});

export const useHttpStore = defineStore("http", {
  state: (): HttpState => ({
    baseUrl,
    authToken: null,
    auth0Client: new Auth0Client({
      domain: import.meta.env.VITE_AUTH0_DOMAIN,
      client_id: import.meta.env.VITE_AUTH0_CLIENT_ID,
      redirect_uri: `${window.location.origin}/redirect`,
      audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    }),
    axios: axios.create({
      baseURL: baseUrl,
      ...axiosBaseConfig,
    }),
  }),
  getters: {},
  actions: {
    async loadToken() {
      if (!this.auth0Client) {
        throw new Error("Auth0 not initialized.");
      } else {
        try {
          this.authToken = await this.auth0Client.getTokenSilently();
          const axiosConfig = {
            baseURL: this.baseUrl as string,
            headers: {
              Authorization: `Bearer ${this.authToken}`,
            },
            ...axiosBaseConfig,
          };
          this.axios = axios.create(axiosConfig);
        } catch (err) {
          console.log("Can't load token. Proceeding as guest.");
        }
      }
    },
  },
});
